
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15 8V5a4 4 0 00-8 0v3M2.592 9.352l-.6 6.4c-.17 1.82-.256 2.73.046 3.432a3 3 0 001.32 1.45C4.03 21 4.944 21 6.771 21h8.458c1.828 0 2.742 0 3.413-.366a3 3 0 001.32-1.45c.302-.703.217-1.612.046-3.432l-.6-6.4c-.144-1.537-.216-2.305-.561-2.886a3 3 0 00-1.292-1.176C16.945 5 16.173 5 14.629 5H7.371c-1.543 0-2.315 0-2.925.29a3 3 0 00-1.292 1.176c-.346.581-.418 1.35-.562 2.886z","stroke":"#232859","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    